<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-row>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-primary">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-ativos"
            >
              <i class="fa fa-info-circle fa-lg tamanhoIcon"></i>
            </b-button>
            <b-popover target="pushs-ativos" triggers="hover focus">
              <template slot="title">Informação</template>
              Este número é um
              <strong>totalizador</strong>
              para os pacotes que estão ativos
              <span class="text-danger">no momento</span>.
              O primeiro valor da soma é o bônus que tem para utilizar
              <strong>todo mês</strong>.
            </b-popover>
            <h4 class="mb-0">{{ pacoteMensal }} + {{ pacoteAdicional }}</h4>
            <p>Pushs ativos</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-info">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ qtdpushsenviados }}</h4>
            <p>Pushs enviados</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-success">
          <b-card-body class="pb-0">
            <h4 class="mb-0">{{ qtdpushsrecebidos }}</h4>
            <p>Pushs recebidos</p>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col sm="6" lg="3">
        <b-card no-body class="bg-danger">
          <b-card-body class="pb-0">
            <b-button
              class="float-right"
              variant="transparent p-0"
              right
              no-caret
              id="pushs-visualizados"
            >
              <i class="fa fa-info-circle fa-lg"></i>
            </b-button>
            <b-popover target="pushs-visualizados" triggers="hover focus">
              <template slot="title">Informação</template>
              A função de pushs visualizados está em versão
              <strong>beta</strong> e poderá apresentar instabilidades.
            </b-popover>
            <h4 class="mb-0">{{ qtdpushsvisualizados }}</h4>
            <p>Pushs visualizados</p>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-card>
          <b-row>
            <b-col xl="6" lg="6" md="6" sm="12">
              <nav>
                <b-pagination
                  :total-rows="getRowCount(items)"
                  :per-page="perPage"
                  v-model="currentPage"
                  prev-text="Anterior"
                  next-text="Próxima"
                />
              </nav>
            </b-col>
            <b-col xl="6" lg="6" md="6" sm="12">
              <b-button
                variant="success"
                class="botaoCadastrarCupom"
                @click="redirect"
              >Cadastrar campanha</b-button>
            </b-col>
          </b-row>
          <b-table
            v-if="items.length > 0"
            :items="items"
            :fields="fields"
            bordered
            striped
            hover
            :current-page="currentPage"
            :per-page="perPage"
          ></b-table>
          <div v-else>
            <center class="mt-3">
              <i class="fa fa-frown-o fa-custom-size"></i>
              <h4>Desculpe, não encontramos nenhuma promoção :(</h4>
              <h5>Para iniciar, clique no botão acima e comece as integrações!</h5>
            </center>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "promocoes",
  components: {
    Loading
  },
  data: function() {
    return {
      isLoading: false,
      temPromocoes: false,
      numCampanhas: 0,
      titulo: "",
      descricao: "",
      items: [],
      fields: [
        "titulo",
        "descricao",
        { key: "datahoracadastro", label: "Cadastro" },
        { key: "datahoradisparopush", label: "Envio" },
        { key: "qtdpushsenviados", label: "Enviados" },
        { key: "qtdpushsrecebidos", label: "Recebidos" },
        { key: "qtdpushsvisualizados", label: "Visualizados" }
      ],
      haveItems: false,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      qtdpushsrecebidos: 0,
      qtdpushsvisualizados: 0,
      qtdpushsenviados: 0,
      pacoteMensal: 0,
      pacoteAdicional: 0,
      modalShow: false
    };
  },
  methods: {
    getRowCount(items) {
      return items.length;
    },
    userLink(cpf) {
      // return `cliente/${cpf.toString()}`;
    },
    rowClicked(item) {
      // const userLink = this.userLink(item.cpf);
      // this.$router.push({ path: userLink });
    },
    redirect() {
      localStorage.setItem("tipoid", 5);
      this.$router.push({ path: `/cadastrar-campanha` });
    },
    async retornaTotalizadores() {
      await axios
        .get(
          `${
            config.default.servidor
          }/gerencial/retorna-totalizadores-push/${localStorage.getItem(
            "enterprise_id"
          )}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          this.qtdpushsrecebidos = response.data.data.qtdpushsrecebidos;
          this.qtdpushsvisualizados = response.data.data.qtdpushsvisualizados;
          this.qtdpushsenviados = response.data.data.qtdpushsenviados;
          this.pacoteMensal = response.data.data.pacotes[0];
          this.pacoteAdicional = response.data.data.pacotes[1];
        });
    },
    async retornaCampanhas() {
      await axios
        .get(
          `${
            config.default.servidor
          }/gerencial/retorna-campanhas/${localStorage.getItem(
            "enterprise_id"
          )}`,
          {
            headers: {
              Authorization: "Basic c2E6QURNQUNDRVNZUw=="
            }
          }
        )
        .then(response => {
          this.items = response.data.data;
        });
    }
  },
  async beforeMount() {
    this.isLoading = true;
    await this.retornaTotalizadores();
    await this.retornaCampanhas();
    this.isLoading = false;
  }
};
</script>

